import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Fri Nov 20 2020
 */
import { Map as IMap, Set as ISet } from 'immutable';
import { CONSTANTS } from '../../../constants';
import logger from '../../logger';
import api from '../../api';
/**
 * @author Tomas Leity
 */

export var ProductSecondarySupplierLayer =
/*#__PURE__*/
function () {
  function ProductSecondarySupplierLayer() {
    _classCallCheck(this, ProductSecondarySupplierLayer);
  }

  _createClass(ProductSecondarySupplierLayer, [{
    key: "findSupplierIds",

    /**
     * Finds secondary {@link Supplier} ids for specified {@link Product} ids.
     *
     * @param productIds Set of {@link Product} ids.
     */
    value: function findSupplierIds(productIds) {
      var apiConfig = {
        responseType: 'json'
      };
      return api(CONSTANTS.API.ENDPOINTS.PRODUCTS_SECONDARY_SUPPLIERS_ID).post({
        productIds: productIds.toArray()
      }, apiConfig).then(function (response) {
        return ISet(response.data.result || []);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Finds secondary {@link Supplier} ids for specified {@link Product} ids. Grouped by product id.
     *
     * @param productIds Set of {@link Product} ids.
     */

  }, {
    key: "findSupplierIdsGroupedByProduct",
    value: function findSupplierIdsGroupedByProduct(productIds) {
      var apiConfig = {
        responseType: 'json'
      };
      return api(CONSTANTS.API.ENDPOINTS.PRODUCTS_SECONDARY_SUPPLIERS_ID_GROUPS).post({
        productIds: productIds.toArray()
      }, apiConfig).then(function (response) {
        var formatted = IMap();

        if (response.data.result) {
          var _arr = Object.keys(response.data.result);

          for (var _i = 0; _i < _arr.length; _i++) {
            var productId = _arr[_i];
            var supplierIds = response.data.result[productId];
            formatted = formatted.set(productId, ISet(supplierIds));
          }
        }

        return formatted;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }]);

  return ProductSecondarySupplierLayer;
}();